import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import styles from './Create.module.css';
import { characterExample, scenarioExample } from '../../assets/images';

// Motion transition animation component
const TransitionAnimation = ({ type }: { type: 'character' | 'scenario' }) => {
  return (
    <div className={styles.transitionOverlay}>
      <div className={`${styles.transitionPanel} ${styles.leftPanel}`}></div>
      <div className={`${styles.transitionPanel} ${styles.rightPanel}`}></div>
      <div className={styles.transitionContent}>
        <div className={styles.transitionIcon}>
          {type === 'character' ? (
            <img src={characterExample} alt="Character" className={styles.transitionImage} />
          ) : (
            <img src={scenarioExample} alt="Scenario" className={styles.transitionImage} />
          )}
        </div>
        <div className={styles.transitionText}>
          {type === 'character' ? 'Creating Character' : 'Building Scenario'}
        </div>
      </div>
    </div>
  );
};

const Create: React.FC = () => {
  const navigate = useNavigate();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [transitionType, setTransitionType] = useState<'character' | 'scenario'>('character');

  const handleCreateCharacter = () => {
    setTransitionType('character');
    setIsTransitioning(true);
    
    // Navigate after a short transition animation
    setTimeout(() => {
      navigate('/create-character');
    }, 600);
  };

  const handleCreateScenario = () => {
    setTransitionType('scenario');
    setIsTransitioning(true);
    
    // Navigate after a short transition animation
    setTimeout(() => {
      navigate('/create-scenario');
    }, 600);
  };

  return (
    <div className={styles.createContainer}>
      {/* Whimsical background elements */}
      <div className={`${styles.floatingShape} ${styles.shape1}`}></div>
      <div className={`${styles.floatingShape} ${styles.shape2}`}></div>
      <div className={`${styles.floatingShape} ${styles.shape3}`}></div>
      <div className={`${styles.floatingShape} ${styles.shape4}`}></div>
      <div className={`${styles.floatingShape} ${styles.shape5}`}></div>
      <div className={`${styles.floatingShape} ${styles.shape6}`}></div>
      <div className={`${styles.floatingShape} ${styles.shape7}`}></div>
      
      <div className={`${styles.particle} ${styles.particle1}`}></div>
      <div className={`${styles.particle} ${styles.particle2}`}></div>
      <div className={`${styles.particle} ${styles.particle3}`}></div>
      <div className={`${styles.particle} ${styles.particle4}`}></div>
      <div className={`${styles.particle} ${styles.particle5}`}></div>
      <div className={`${styles.particle} ${styles.particle6}`}></div>
      <div className={`${styles.particle} ${styles.particle7}`}></div>
      <div className={`${styles.particle} ${styles.particle8}`}></div>
      
      {/* Shooting stars */}
      <div className={styles.shootingStar}></div>
      <div className={`${styles.shootingStar} ${styles.shootingStar2}`}></div>
      
      {isTransitioning && <TransitionAnimation type={transitionType} />}
      
      <h1 className={styles.title}>
        <span className={styles.titleChar} style={{ animationDelay: '0.1s' }}>c</span>
        <span className={styles.titleChar} style={{ animationDelay: '0.2s' }}>r</span>
        <span className={styles.titleChar} style={{ animationDelay: '0.3s' }}>e</span>
        <span className={styles.titleChar} style={{ animationDelay: '0.4s' }}>a</span>
        <span className={styles.titleChar} style={{ animationDelay: '0.5s' }}>t</span>
        <span className={styles.titleChar} style={{ animationDelay: '0.6s' }}>e</span>
      </h1>
      <p className={styles.subtitle}>what would you like to create today?</p>
      
      <div className={styles.buttonsContainer}>
        <button 
          className={`${styles.createButton} ${styles.characterButton}`}
          onClick={handleCreateCharacter}
        >
          <div className={styles.buttonContent}>
            <div className={styles.buttonIcon}>
              <img src={characterExample} alt="Character" className={styles.iconImage} />
            </div>
            <div className={styles.buttonTextContainer}>
              <h2 className={styles.buttonTitle}>character</h2>
              <p className={styles.buttonDescription}>design a unique character with personality and backstory</p>
            </div>
          </div>
        </button>
        
        <button 
          className={`${styles.createButton} ${styles.scenarioButton}`}
          onClick={handleCreateScenario}
        >
          <div className={styles.buttonContent}>
            <div className={styles.buttonIcon}>
              <img src={scenarioExample} alt="Scenario" className={styles.iconImage} />
            </div>
            <div className={styles.buttonTextContainer}>
              <h2 className={styles.buttonTitle}>scenario</h2>
              <p className={styles.buttonDescription}>build an interactive world with multiple characters</p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default Create; 